import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Publisher as PublisherComponent } from './components/publisher';
import { IPublisher } from './models';

export const Publisher = createWidget<unknown, IPublisher>()(PublisherComponent);
